import { CLIENT_VAL_PASS, CLIENT_VAL_PASS_ERROR, CLIENT_VAL_PASS_HIDE_ERROR, CLIENT_VAL_PASS_START_LOADER, CLIENT_VAL_PASS_STOP_LOADER, } from "../interface/IClientValPassword";
const initState = {
    data: {
        isOtpSucesss: false,
        loginFlow: "",
        message: "",
        status: false,
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ClientValPassword = (state = initState, action) => {
    switch (action.type) {
        case CLIENT_VAL_PASS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case CLIENT_VAL_PASS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CLIENT_VAL_PASS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CLIENT_VAL_PASS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case CLIENT_VAL_PASS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ClientValPassword;
